export type MonthProduction = {
  month: string
  units: number
  volume: number
}

export const production = {
  goalUnits: 8,
  goalVolume: 3000000,
  mtdUnits: 5,
  mtdVolume: 1847500,
  lockedUnits: 3,
  pullThrough: 0.72,
  avgDaysToClose: 27,
}

export const monthlyProduction: MonthProduction[] = [
  { month: 'Mar', units: 6, volume: 2140000 },
  { month: 'Apr', units: 7, volume: 2620000 },
  { month: 'May', units: 5, volume: 1780000 },
  { month: 'Jun', units: 9, volume: 3310000 },
  { month: 'Jul', units: 7, volume: 2455000 },
  { month: 'Aug', units: 5, volume: 1847500 },
]
